import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 px-4 font-body">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_sanjaya-ai-1/artifacts/8tjvhfc4_Gemini_Generated_Image_8jnxm88jnxm88jnx.png" 
                alt="Sanjaya Logo" 
                className="h-10 w-auto"
              />
            </div>
            <p className="text-gray-400">
              Daily emotional support for children through caring conversations.
            </p>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-blue-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-blue-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-gray-400 hover:text-blue-400 transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-blue-400 transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/for-observers" className="text-gray-400 hover:text-blue-400 transition-colors">
                  For Observers
                </Link>
              </li>
              <li>
                <Link to="/for-principals" className="text-gray-400 hover:text-blue-400 transition-colors">
                  For Principals
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-blue-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-blue-400 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-blue-400 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-gray-400">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <span>contact@sanjaya.com</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <span>+91 8291188188</span>
              </li>
              <li className="flex items-start gap-2 text-gray-400">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>103, 1st Floor, Kshitij Building, Veera Desai Road, Dattaguru Nagar, Azad Nagar, Andheri West, Mumbai, Maharashtra - 400053</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col items-center justify-center mb-6">
            <div className="flex items-center gap-3 bg-gray-800 rounded-xl px-6 py-3">
              <img
                src="/images/skill-bharat-logo.jpg.png"
                alt="Skill Bharat Association"
                className="h-12 w-12 object-contain"
              />
              <div className="text-left">
                <p className="text-xs text-gray-400 uppercase tracking-widest">Supported by</p>
                <p className="text-white font-semibold text-sm">Skill Bharat Association</p>
              </div>
            </div>
          </div>

          <div className="text-center text-gray-400">
            <p>© {new Date().getFullYear()} Sanjaya. Empowering children across India with emotional support.</p>
            <div className="mt-4 flex justify-center gap-4 text-sm">
              <Link to="/privacy" className="hover:text-blue-400 transition-colors">Privacy</Link>
              <span>•</span>
              <Link to="/terms" className="hover:text-blue-400 transition-colors">Terms</Link>
              <span>•</span>
              <Link to="/contact" className="hover:text-blue-400 transition-colors">Contact</Link>
            </div>
            <p className="mt-4 text-sm text-gray-500">
              Built by{' '}
              <a
                href="https://shiftora.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="text-emerald-400 hover:text-emerald-300 transition-colors font-medium"
              >
                shiftora.ai
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;